import { render, staticRenderFns } from "./DetailTitle.vue?vue&type=template&id=6ec3e854&scoped=true"
import script from "./DetailTitle.vue?vue&type=script&lang=js"
export * from "./DetailTitle.vue?vue&type=script&lang=js"
import style0 from "./DetailTitle.vue?vue&type=style&index=0&id=6ec3e854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3e854",
  null
  
)

export default component.exports